import React from 'react';

import { useTheme } from 'components/core/theme-provider';
import { cn } from 'lib/utils';

interface ConfigurationHeaderProps {
  title?: string;
  subtitle?: string;
  icon?: React.ReactNode;
  badge?: React.ReactNode;
  titleClassName?: string;
  subtitleClassName?: string;
}

function ConfigurationHeader({
  title,
  subtitle,
  icon,
  badge,
  titleClassName,
  subtitleClassName,
}: ConfigurationHeaderProps) {
  const { theme } = useTheme();
  const titleColor = theme === 'dark' ? 'text-true-white' : 'text-grey-900';
  const subtitleColor = theme === 'dark' ? 'text-grey-300' : 'text-grey-700';

  if (!icon && !title && !subtitle && !badge) {
    return null;
  }

  return (
    <div className="flex min-w-0 flex-1 flex-col gap-3 sm:max-w-[604px]">
      {(icon || title || badge) && (
        <div className="flex min-w-0 items-center gap-2">
          {icon}
          {title && (
            <h1
              className={cn(
                'min-w-0 text-xl font-medium leading-heading 2xl:text-2xl',
                titleColor,
                titleClassName,
              )}
            >
              {title}
            </h1>
          )}
          {badge}
        </div>
      )}
      {subtitle && (
        <p
          className={cn(
            'min-w-0 text-sm font-normal leading-body 2xl:text-base',
            subtitleColor,
            subtitleClassName,
          )}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}

export default ConfigurationHeader;
